import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
const Badge = ({ children, count, max = 99, className = '', styles = {}, badgeStyles = {}, showIndicatorOnly = false, position = 'top-right', backgroundColor, textColor }) => {
    const badgeStyle = Object.assign(Object.assign(Object.assign({}, badgeStyles), (backgroundColor && { backgroundColor })), (textColor && { color: textColor }));
    return (_jsxs("div", { className: classNames('uxpcore_badge__container', className), style: styles, children: [children, _jsx("div", { className: classNames("uxpcore_badge__badge", `uxpcore_badge__badge--${position}`, {
                    "uxpcore_badge__badge--indicator-only": showIndicatorOnly
                }), style: badgeStyle, children: !showIndicatorOnly
                    ? _jsx(_Fragment, { children: count > max ? `${max}+` : count })
                    : null })] }));
};
export default Badge;
